// Chemin: C:\gestion-copro\src\Router.tsx
// Configuration des routes - COPRO PROTECT
// Session 34 : ajout routes Messagerie et Gmail callback
// Session 41 : ajout routes Courriers
// Session 42 : ajout route détail courrier
// Session 45 : ajout Landing Page comme point d'entrée
// Session 46 : ajout route détail document
// Session 54 : ajout routes Admin SaaS + portails copropriétés
// Session 56 : ajout routes Espace Copropriétaire (/espace-copro/*)
// Session 60 : ajout page Sauvegardes
// Session 67 : ajout routes Vérification Comptable
// Session 78 : ajout pages juridiques (CGU, Mentions légales, Politique confidentialité)
// Session 89 : ajout route Signature Mandat de Coordination (Gouvernance V2)
// Session 94 : ajout route Calendrier / Agenda
// Session 100 : Chantier ESCALATOR — ajout routes VIGIE (/vigie/*) + inscription VIGIE
// Session 105 : CoproprieteProvider DÉPLACÉ ICI (à l'intérieur du BrowserRouter)
//               → permet la lecture du paramètre ?copro= via useSearchParams
//               → résout le bug multi-copropriétés Admin SaaS
// Session 122 : ajout route /vigie/contacts (ContactsVigiePage — CRUD interlocuteurs VIGIE)
// Session 123 : ajout routes /vigie/signalements/* (module signalement VIGIE ESCALATOR — supprimé S235)
// Session 125 : ajout routes /vigie/dossiers/* (module affaires VIGIE ESCALATOR)
// Session 130 : ajout route /vigie/calendrier (module échéances VIGIE)
// Session 148 : ajout route /admin-saas/utilisateurs-vigie (panneau admin SaaS)
// Session 149 : ajout route /vigie/faq (FAQ / Aide)
// Session 151 : ajout route /vigie/nous-contacter (remplace BoutonAideFlottant)
// Session 185 : ajout route /vigie/export-donnees (export RGPD portabilité)
// Session 187 : ajout route /admin-saas/crm (CRM — pipeline de prospection)
// Session 188 : ajout routes /apporteur/* (espace partenaire commercial — Alain)
// Session 190 : ajout route /auth/gmail/crm/callback (OAuth Gmail CRM)
// Session 192 : ajout route /admin-saas/crm/prospect/:id (fiche prospect CRM)
// Session 198 : ajout route /admin-saas/apporteur/:userId (fiche apporteur)
// Session 224 : ajout route /admin-saas/commissions (dashboard commissions apporteurs)
// Session 195 : ajout route /vigie/documents/ajouter (AjouterDocumentVigiePage — tunnel GED SENTINELLE)
// Session 217 : ajout routes /vigie/comptabilite/* (module vérification comptable VIGIE ESCALATOR)
// Session 217B : correction imbrication routes comptabilite + ajout route /vigie/bailleur (Suivi bailleur)
// Session 214 : ajout route /admin/sentinelle (SENTINELLE CS — chat plein écran)
// Session 235 : routes /vigie/signalements/* remplacées par redirections vers /vigie/dossiers
// Session 239 : ajout route /admin-saas/demos (module gestion des démos commerciales)
// Session 245 : ajout route /vigie/profil (MonProfilVigiePage — profil copropriété, syndic, lots, tantièmes)
// Session 247 : ajout route /vigie/kit-demarrage (KitDemarrageVigiePage — kit de démarrage guidé)
// Session 265 : /vigie/comptabilite → MaComptabilitePage (module fusionné charges+location)
//               /vigie/bailleur → Navigate vers /vigie/comptabilite (Suivi bailleur absorbé)
//               Suppression routes /vigie/comptabilite/:id et import VerificationComptableVigiePage/VerificationDetailVigiePage/SuiviBailleurVigiePage

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CoproprieteProvider } from './context/CoproprieteContext';
import { ChatProvider } from './context/ChatContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import AdminSaasLayout from './components/layout/AdminSaasLayout';
import CoproprietaireLayout from './components/layout/CoproprietaireLayout';
import VigieLayout from './components/layout/VigieLayout'; // Session 100
import ApporteurLayout from './components/layout/ApporteurLayout'; // Session 188
import ChatPanel from './components/chat/ChatPanel';

// Pages publiques
import InscriptionPage from './pages/public/InscriptionPage';
import InscriptionConfirmationPage from './pages/public/InscriptionConfirmationPage';
import InscriptionVigiePage from './pages/public/InscriptionVigiePage'; // Session 100
import ConfirmationVigiePage from './pages/public/ConfirmationVigiePage'; // Session 100
import SignalerPage from './pages/public/SignalerPage';
import ConfirmationPage from './pages/public/ConfirmationPage';
import LandingPage from './pages/public/LandingPage';
import CoproprietePortalPage from './pages/public/CoproprietePortalPage';
import MentionsLegalesPage from './pages/public/MentionsLegalesPage'; // Session 78
import CGUPage from './pages/public/CGUPage'; // Session 78
import PolitiqueConfidentialitePage from './pages/public/PolitiqueConfidentialitePage'; // Session 78

// Pages auth
import LoginPage from './pages/auth/LoginPage';
import GmailCallbackPage from './pages/auth/GmailCallbackPage';
import GmailCrmCallbackPage from './pages/auth/GmailCrmCallbackPage'; // Session 190

// Pages admin (interface client/secrétaire)
import DashboardPage from './pages/admin/DashboardPage';
import SignalementsPage from './pages/admin/SignalementsPage';
import SignalementDetailPage from './pages/admin/SignalementDetailPage';
import CoproprietePage from './pages/admin/CoproprietePage';
import LotsPage from './pages/admin/LotsPage';
import CoproprietairesPage from './pages/admin/CoproprietairesPage';
import ConseilSyndicalPage from './pages/admin/ConseilSyndicalPage';
import InterlocuteursPage from './pages/admin/InterlocuteursPage';
import InterlocuteurFormPage from './pages/admin/InterlocuteurFormPage';
import DocumentsPage from './pages/admin/DocumentsPage';
import DocumentDetailPage from './pages/admin/DocumentDetailPage';
import AffairesPage from './pages/admin/AffairesPage';
import AffaireFormPage from './pages/admin/AffaireFormPage';
import AffaireDetailPage from './pages/admin/AffaireDetailPage';
import MessageriePage from './pages/admin/MessageriePage';
import CourriersPage from './pages/admin/CourriersPage';
import CourrierFormPage from './pages/admin/CourrierFormPage';
import CourrierDetailPage from './pages/admin/CourrierDetailPage';
import VerificationComptablePage from './pages/admin/VerificationComptablePage'; // Session 67
import VerificationDetailPage from './pages/admin/VerificationDetailPage'; // Session 67
import MandatSignaturePage from './pages/admin/MandatSignaturePage'; // Session 89
import CalendrierPage from './pages/admin/CalendrierPage'; // Session 94
import ExportDonneesCSPage from './pages/admin/ExportDonneesCSPage'; // Session 213
import SentinelleCSPage from './pages/admin/SentinelleCSPage'; // Session 214

// Pages Admin SaaS (Dominique / DOM TECH & SERVICES)
import DashboardSaasPage from './pages/admin-saas/DashboardSaasPage';
import CoproprietesListPage from './pages/admin-saas/CoproprietesListPage';
import ConfigPortailPage from './pages/admin-saas/ConfigPortailPage';
import SauvegardesPage from './pages/admin-saas/SauvegardesPage';
import UtilisateursVigiePage from './pages/admin-saas/UtilisateursVigiePage'; // Session 148
import FeedbackSaasPage from './pages/admin-saas/FeedbackSaasPage'; // Session 149
import CrmPipelinePage from './pages/admin-saas/CrmPipelinePage'; // Session 187
import DashboardCommissionsPage from './pages/admin-saas/DashboardCommissionsPage'; // Session 224
import GestionDemosPage from './pages/admin-saas/GestionDemosPage'; // Session 239
import NettoyageGEDPage from './pages/admin-saas/NettoyageGEDPage'; // Session 255
import CrmProspectDetailPage from './pages/admin-saas/CrmProspectDetailPage'; // Session 192
import ApporteurDetailPage from './pages/admin-saas/ApporteurDetailPage'; // Session 198

// Pages Espace Copropriétaire (Session 56)
import DashboardCoproprietairePage from './pages/coproprietaire/DashboardCoproprietairePage';
import NouveauSignalementPage from './pages/coproprietaire/NouveauSignalementPage';
import MesSignalementsPage from './pages/coproprietaire/MesSignalementsPage';
import DocumentsPublicsPage from './pages/coproprietaire/DocumentsPublicsPage';

// Pages VIGIE — Espace copropriétaire autonome (Session 100)
import DashboardVigiePage from './pages/vigie/DashboardVigiePage';
import SentinelleVigiePage from './pages/vigie/SentinelleVigiePage';
import CourrierFormVigiePage from './pages/vigie/CourrierFormVigiePage';
import CourrierDetailVigiePage from './pages/vigie/CourrierDetailVigiePage';
import DocumentsVigiePage from './pages/vigie/DocumentsVigiePage';
import DocumentDetailVigiePage from './pages/vigie/DocumentDetailVigiePage';
import ContactsVigiePage from './pages/vigie/ContactsVigiePage'; // Session 122
import SignalementsVigiePage from './pages/vigie/SignalementsVigiePage'; // Session 123
import SignalementFormVigiePage from './pages/vigie/SignalementFormVigiePage'; // Session 123
import SignalementDetailVigiePage from './pages/vigie/SignalementDetailVigiePage'; // Session 123
import AffairesVigiePage from './pages/vigie/AffairesVigiePage'; // Session 125
import AffaireFormVigiePage from './pages/vigie/AffaireFormVigiePage'; // Session 125
import AffaireDetailVigiePage from './pages/vigie/AffaireDetailVigiePage'; // Session 125
import CalendrierVigiePage from './pages/vigie/CalendrierVigiePage'; // Session 130
import FAQVigiePage from './pages/vigie/FAQVigiePage'; // Session 149
import NousContacterVigiePage from './pages/vigie/NousContacterVigiePage'; // Session 151
import ExportDonneesVigiePage from './pages/vigie/ExportDonneesVigiePage'; // Session 185
import MaComptabilitePage from './pages/vigie/MaComptabilitePage'; // Session 265 — module comptabilité fusionné (charges copro + location bailleur)
import AjouterDocumentVigiePage from './pages/vigie/AjouterDocumentVigiePage'; // Session 195 — tunnel GED SENTINELLE
import MonProfilVigiePage from './pages/vigie/MonProfilVigiePage'; // Session 245 — profil copropriété (syndic, lots, tantièmes)
import KitDemarrageVigiePage from './pages/vigie/KitDemarrageVigiePage'; // Session 247 — kit de démarrage guidé
import FicheLocataireVigiePage from './pages/vigie/FicheLocataireVigiePage'; // Session 268 — fiche locataire + quittance PDF

// Pages Apporteur — Espace partenaire commercial (Session 188)
import ApporteurPipelinePage from './pages/apporteur/ApporteurPipelinePage';
import ApporteurCommissionsPage from './pages/apporteur/ApporteurCommissionsPage';

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <CoproprieteProvider>
        <ChatProvider>
        <Routes>
          
          {/* ============================================ */}
          {/* PAGES PUBLIQUES                             */}
          {/* ============================================ */}
          
          {/* Landing page Copro Protect - Point d'entrée principal */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Pages juridiques (Session 78) */}
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/cgu" element={<CGUPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          
          {/* Inscription copropriétaire (rattaché à un CS) */}
          <Route path="/inscription" element={<InscriptionPage />} />
          <Route path="/inscription-confirmation" element={<InscriptionConfirmationPage />} />
          
          {/* Inscription VIGIE — copropriétaire autonome (Session 100) */}
          <Route path="/inscription-vigie" element={<InscriptionVigiePage />} />
          <Route path="/confirmation-vigie" element={<ConfirmationVigiePage />} />
          
          {/* Connexion */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Confirmation signalement */}
          <Route path="/confirmation" element={<ConfirmationPage />} />
          
          {/* ============================================ */}
          {/* CALLBACKS OAUTH                             */}
          {/* ============================================ */}
          
          {/* Gmail copropriété (CS) */}
          <Route 
            path="/auth/gmail/callback" 
            element={
              <ProtectedRoute requireCS={true}>
                <GmailCallbackPage />
              </ProtectedRoute>
            } 
          />

          {/* Gmail CRM (Admin SaaS / Apporteur) — Session 190 */}
          <Route 
            path="/auth/gmail/crm/callback" 
            element={
              <ProtectedRoute>
                <GmailCrmCallbackPage />
              </ProtectedRoute>
            } 
          />
          
          {/* ============================================ */}
          {/* ROUTES VIGIE (Session 100 — Escalator)      */}
          {/* Copropriétaire autonome — formule VIGIE     */}
          {/* ============================================ */}
          
          {/* Session 118 : /vigie redirige vers /vigie/sentinelle (SENTINELLE = accueil) */}
          <Route 
            path="/vigie" 
            element={
              <ProtectedRoute requireVigie={true}>
                <Navigate to="/vigie/sentinelle" replace />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/vigie/sentinelle" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <SentinelleVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/vigie/dashboard" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <DashboardVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 256 : GED unifiée — "Mes correspondances" fusionné dans "Mes documents" */}
          {/* Session 259 : formulaire et détail courrier VIGIE activés — liste reste redirigée vers GED */}
          <Route path="/vigie/courriers" element={<Navigate to="/vigie/documents" replace />} />
          <Route
            path="/vigie/courriers/nouveau"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <CourrierFormVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vigie/courriers/:id"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <CourrierDetailVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vigie/courriers/:id/modifier"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <CourrierFormVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          <Route 
            path="/vigie/documents" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <DocumentsVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 195 : Tunnel GED SENTINELLE — DOIT être AVANT /vigie/documents/:id */}
          {/* Protection interne : accès direct sans state fromSentinelle → redirect SENTINELLE */}
          <Route
            path="/vigie/documents/ajouter"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <AjouterDocumentVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          <Route 
            path="/vigie/documents/:id" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <DocumentDetailVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 122 */}
          <Route 
            path="/vigie/contacts" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <ContactsVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 235 — Signalements VIGIE supprimés — redirection vers Mes dossiers */}
          {/* Les données Firestore restent intactes, accessibles depuis les fiches dossier */}
          <Route path="/vigie/signalements" element={<Navigate to="/vigie/dossiers" replace />} />
          <Route path="/vigie/signalements/nouveau" element={<Navigate to="/vigie/dossiers" replace />} />
          <Route path="/vigie/signalements/:id" element={<Navigate to="/vigie/dossiers" replace />} />

          {/* Session 125 — Dossiers/Affaires VIGIE */}
          <Route 
            path="/vigie/dossiers" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <AffairesVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/vigie/dossiers/nouveau" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <AffaireFormVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/vigie/dossiers/:id" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <AffaireDetailVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/vigie/dossiers/:id/modifier" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <AffaireFormVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 130 — Calendrier VIGIE */}
          <Route 
            path="/vigie/calendrier" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <CalendrierVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 149 — FAQ VIGIE */}
          <Route 
            path="/vigie/faq" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <FAQVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 151 — Nous contacter VIGIE */}
          <Route 
            path="/vigie/nous-contacter" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <NousContacterVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 185 — Export données VIGIE (RGPD) */}
          <Route 
            path="/vigie/export-donnees" 
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <ExportDonneesVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 265 — Ma comptabilité VIGIE (module fusionné : charges copro + location bailleur) */}
          {/* Remplace VerificationComptableVigiePage + SuiviBailleurVigiePage */}
          <Route
            path="/vigie/comptabilite"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <MaComptabilitePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          {/* Session 265 — Suivi bailleur absorbé dans Ma comptabilité (onglet Ma location) */}
          <Route
            path="/vigie/bailleur"
            element={<Navigate to="/vigie/comptabilite" replace />}
          />

          {/* Session 268 — Fiche locataire dédiée + génération quittance PDF */}
          <Route
            path="/vigie/locataires/:id"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <FicheLocataireVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          {/* Session 247 — Kit de démarrage guidé VIGIE */}
          <Route
            path="/vigie/kit-demarrage"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <KitDemarrageVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          {/* Session 245 — Profil copropriété VIGIE (syndic, promoteur, lots, tantièmes) */}
          <Route
            path="/vigie/profil"
            element={
              <ProtectedRoute requireVigie={true}>
                <VigieLayout>
                  <MonProfilVigiePage />
                </VigieLayout>
              </ProtectedRoute>
            }
          />

          {/* ============================================ */}
          {/* ROUTES ADMIN SAAS                           */}
          {/* ============================================ */}

          <Route 
            path="/admin-saas" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <DashboardSaasPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin-saas/coproprietes" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <CoproprietesListPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin-saas/config" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <ConfigPortailPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin-saas/sauvegardes" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <SauvegardesPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 148 */}
          <Route 
            path="/admin-saas/utilisateurs-vigie" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <UtilisateursVigiePage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 149 */}
          <Route 
            path="/admin-saas/feedback" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <FeedbackSaasPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 187 — CRM Pipeline */}
          <Route 
            path="/admin-saas/crm" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <CrmPipelinePage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 192 — Fiche prospect CRM */}
          <Route 
            path="/admin-saas/crm/prospect/:id" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <CrmProspectDetailPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 198 — Fiche apporteur */}
          <Route 
            path="/admin-saas/apporteur/:userId" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <ApporteurDetailPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 224 — Commissions apporteurs */}
          <Route 
            path="/admin-saas/commissions" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <DashboardCommissionsPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 239 — Démos commerciales premium */}
          <Route 
            path="/admin-saas/demos" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <GestionDemosPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 255 — Nettoyage GED (documents zombies) */}
          <Route 
            path="/admin-saas/nettoyage-ged" 
            element={
              <ProtectedRoute requireSaas={true}>
                <AdminSaasLayout>
                  <NettoyageGEDPage />
                </AdminSaasLayout>
              </ProtectedRoute>
            } 
          />

          {/* ============================================ */}
          {/* ROUTES APPORTEUR (Session 188)              */}
          {/* ============================================ */}

          <Route 
            path="/apporteur" 
            element={
              <ProtectedRoute requireApporteur={true}>
                <Navigate to="/apporteur/pipeline" replace />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/apporteur/pipeline" 
            element={
              <ProtectedRoute requireApporteur={true}>
                <ApporteurLayout>
                  <ApporteurPipelinePage />
                </ApporteurLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/apporteur/commissions" 
            element={
              <ProtectedRoute requireApporteur={true}>
                <ApporteurLayout>
                  <ApporteurCommissionsPage />
                </ApporteurLayout>
              </ProtectedRoute>
            } 
          />

          {/* Session 223 — Fiche prospect CRM apporteur */}
          <Route 
            path="/apporteur/crm/prospect/:id" 
            element={
              <ProtectedRoute requireApporteur={true}>
                <ApporteurLayout>
                  <CrmProspectDetailPage />
                </ApporteurLayout>
              </ProtectedRoute>
            } 
          />

          {/* ============================================ */}
          {/* ROUTES ESPACE COPROPRIÉTAIRE (Session 56)  */}
          {/* ============================================ */}

          <Route 
            path="/espace-copro" 
            element={
              <ProtectedRoute requireActive={true}>
                <CoproprietaireLayout>
                  <DashboardCoproprietairePage />
                </CoproprietaireLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/espace-copro/signalements" 
            element={
              <ProtectedRoute requireActive={true}>
                <CoproprietaireLayout>
                  <MesSignalementsPage />
                </CoproprietaireLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/espace-copro/signalements/nouveau" 
            element={
              <ProtectedRoute requireActive={true}>
                <CoproprietaireLayout>
                  <NouveauSignalementPage />
                </CoproprietaireLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/espace-copro/documents" 
            element={
              <ProtectedRoute requireActive={true}>
                <CoproprietaireLayout>
                  <DocumentsPublicsPage />
                </CoproprietaireLayout>
              </ProtectedRoute>
            } 
          />

          {/* ============================================ */}
          {/* ROUTES ADMIN CS                             */}
          {/* ============================================ */}

          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <DashboardPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/copropriete" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CoproprietePage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/lots" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <LotsPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/coproprietaires" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CoproprietairesPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/conseil-syndical" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <ConseilSyndicalPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/interlocuteurs" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <InterlocuteursPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/interlocuteurs/nouveau" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <InterlocuteurFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/interlocuteurs/:id/modifier" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <InterlocuteurFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/documents" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <DocumentsPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/documents/:id" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <DocumentDetailPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/affaires" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <AffairesPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/affaires/nouveau" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <AffaireFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/affaires/:id" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <AffaireDetailPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/admin/affaires/:id/modifier" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <AffaireFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          {/* ============================================ */}
          {/* CALENDRIER / AGENDA (Session 94)            */}
          {/* ============================================ */}
          
          <Route 
            path="/admin/calendrier" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CalendrierPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />

          {/* ============================================ */}
          {/* SENTINELLE CS (Session 214)                  */}
          {/* ============================================ */}

          <Route
            path="/admin/sentinelle"
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <SentinelleCSPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          {/* ============================================ */}
          {/* EXPORT DONNÉES RGPD CS (Session 213)        */}
          {/* ============================================ */}

          <Route
            path="/admin/export-donnees"
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <ExportDonneesCSPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          
          {/* ============================================ */}
          {/* VÉRIFICATION COMPTABLE (Session 67)         */}
          {/* ============================================ */}
          
          <Route 
            path="/admin/comptabilite" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <VerificationComptablePage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/comptabilite/:id" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <VerificationDetailPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          {/* ============================================ */}
          {/* MESSAGERIE ET COURRIERS                     */}
          {/* ============================================ */}
          
          <Route 
            path="/admin/messagerie" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <MessageriePage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/courriers" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CourriersPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/courriers/nouveau" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CourrierFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/courriers/:id" 
            element={
              <ProtectedRoute requireCS={true}>
                <CourrierDetailPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/courriers/:id/modifier" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <CourrierFormPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          {/* ============================================ */}
          {/* SIGNALEMENTS                                */}
          {/* ============================================ */}
          
          <Route 
            path="/admin/signalements" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <SignalementsPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/signalements/:id" 
            element={
              <ProtectedRoute requireCS={true}>
                <AdminLayout>
                  <SignalementDetailPage />
                </AdminLayout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/signaler" 
            element={
              <ProtectedRoute requireActive={true}>
                <SignalerPage />
              </ProtectedRoute>
            } 
          />

          {/* Mandat de coordination (Session 89) */}
          <Route 
            path="/admin/mandat/signature" 
            element={
              <ProtectedRoute requireCS={true}>
                <MandatSignaturePage />
              </ProtectedRoute>
            } 
          />
          
          {/* ============================================ */}
          {/* PORTAILS COPROPRIÉTÉS (route dynamique)     */}
          {/* ============================================ */}
          
          <Route path="/:slug" element={<CoproprietePortalPage />} />
          
          {/* ============================================ */}
          {/* 404 - Redirection vers accueil              */}
          {/* ============================================ */}
          
          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
        </ChatProvider>
      </CoproprieteProvider>
    </BrowserRouter>
  );
};

export default Router;
